import React, { useState, useEffect } from 'react'
import ContainerPaymentMethodPrime from '../ContainerPaymentMethodPrime'
import PubSub from 'services/PubSub/'
import { actionsType } from 'config/constants'
import Loader from 'components/Loader'
import { HtmlParse } from 'utils'
import dayjs from 'dayjs';
import CMSFactory from "factories/CMS";
import PrimeService from 'services/Prime';
import TagManagerService from 'services/TagManager/';
import StorageService from 'services/StorageService';
import InputText from 'components/Forms/Inputs/InputText';
import style from './style.scss' //NOSONAR
import TitleWithBar from 'components/TitleWithBar'

const PaymentMethodPrime = ({ payload }) => {
    const [cardSelected, setCardSelected] = useState(null)
    const [loading, setLoading] = useState(false)
    const [testPeriod, setTestPeriod] = useState(false)
    const [cupon, setCupon] = useState(null)
    const callbackSuccess = payload?.value?.callbackSuccess || (() => {})
    const callbackGoBack = payload?.value?.callbackGoBack || (() => {})
    const title = payload?.value?.title || 'Agrega un medio de pago'

    const getStatusEndPrime = () => {
        return PrimeService.getSuscription().then(res => {
            if((res?.data?.data?.status === 6) || (res?.data?.data?.status === 7)){
                const endDate = res?.data?.data?.benefit_end_date;
                return (endDate);
            } else {
                return(false)
            }
        })
    }

    useEffect(() => {
        getStatusEndPrime().then((response) => {
            if(response) {
                if(CMSFactory.milliseconds(response) < CMSFactory.milliseconds('')){
                    setTestPeriod(null);
                } else {
                    setTestPeriod(dayjs(response).format('DD/MM/YYYY'));
                }
            }else {
                setTestPeriod(dayjs().add(15, 'day').format('DD/MM/YYYY'));
            }
        })
    }, []);

    const header = payload?.value?.header || (
        <>
            {testPeriod && <p className="drawer-payment-method-prime-paragraph">
                Una vez finalizado tu período de prueba ({testPeriod}) <strong>se te cobrarán $25.000 en la tarjeta de crédito que registres a continuación</strong> a través de Webpay para mantener tus beneficios por los próximos 6 meses.
            </p>}
            {!testPeriod && <p className="drawer-payment-method-prime-paragraph">
                <strong>Se te cobrarán $25.000 en la tarjeta de crédito que registres a continuación</strong> a través de Webpay para mantener tus beneficios por los próximos 6 meses.
            </p>}
        </>
    )

    const goToBack = () => {
        if(loading) return false;

        const userData = StorageService.getSecureItem('userData');
        let userId = userData?.gtmSegment;

        if (title === 'Agrega un medio de pago'){
            TagManagerService.interaction('Clic botón volver Step 2 Inscripción: Ingresar medio de pago', userId, 'Jumbo Prime');
        }else if (title === 'Renueva tu suscripción'){
            TagManagerService.interaction('Clic modal renovar suscripción: Volver', userId, 'Jumbo Prime');
        }        

        if (payload?.value?.change) {
            setTimeout(() => {
                PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN, {
                    ...payload?.value,
                    cards: true,
                    init: false,
                    change: false,
                })
            }, 450)
        } else {
            callbackGoBack()
        }

        PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE)
    }

    const handleContinue = () => {

        const userData = StorageService.getSecureItem('userData');
        let userId = userData?.gtmSegment;

        let paymentMethod = cardSelected?.paymentMethod;

        if (title === 'Agrega un medio de pago'){
            TagManagerService.interaction('Step 2 Inscripción: Ingresar medio de pago', paymentMethod, 'Jumbo Prime');
        }else if (title === 'Renueva tu suscripción'){
            TagManagerService.interaction('Clic modal renovar suscripción: continuar', userId, 'Jumbo Prime');
        }

        if(loading) return false;

        setLoading(true)
        if(callbackSuccess){
            callbackSuccess(cardSelected, cupon).then((response) => {
                if(response.message.includes('Bad coupon')){
                    setTimeout(() => {
                        PubSub.dispatch('open_snackbar',{
                            titleButtonMobile: '',
                            titleButtonDesktop: '',
                            TitleMobile: 'Código de cupón incorrecto',
                            TitleDesktop: 'Código de cupón incorrecto',
                            Subtitle:'Por favor, revise el código y reintente su suscripción',
                            timer: 15000,
                            type: 'couponPrime'
                        });
                    },0);
                }
                setLoading(false)
            })
        }else{
            setLoading(false)
        }
    }

    const callbackSelectCard = (selected) => {
        setCardSelected(selected)
    }

    const setCouponCode = (name, validate, value) => {
        setCupon(value)
    }

    return (
        <div className={'drawer-container drawer-payment-method-prime-container'}>
            <h1 className="drawer-title drawer-payment-method-prime-title">{title}</h1>
            <div className={'drawer-scroll '}>
                <div className="drawer-payment-method-prime-content">
                    <>{HtmlParse(header)}</>
                    {loading && (
                        <div className={'cards-list-loader'}>
                            <Loader />
                        </div>
                    )}
                    {!loading && <div>
                        <TitleWithBar title="Cupón" />
                        <InputText
                            label={''}
                            placeholder={'Ej: 6ADHBW7F3P4TU1'}
                            type={'text'}
                            maxLength={14}
                            callbackOnChange={setCouponCode}
                            callbackValidate={() => { return true}}
                            message={{
                                'error': 'Formato de cupón incorrecto',
                            }}
                        />
                    </div>}
                    {!loading && <ContainerPaymentMethodPrime payload={payload} callbackOnClick={callbackSelectCard} />}
                </div>
            </div>
            <div className="drawer-actions drawer-payment-method-prime-actions">
                <button className="secundary-btn" onClick={() => goToBack()}>
                    Volver
                </button>
                <button className={cardSelected ? 'primary-btn' : 'disabled-btn'} onClick={() => handleContinue()}>
                    Continuar
                </button>
            </div>
        </div>
    )
}

export default PaymentMethodPrime
